import React from 'react'
import { makeStyles } from '@mui/styles'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Avatar from '@mui/material/Avatar'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'

import PartnerTierLabel from './PartnerTierLabel'

const useStyles = makeStyles(theme => ({
  avatar: {
    marginRight: theme.spacing(2),
    height: theme.spacing(8),
    width: theme.spacing(8),
  },
  bioButton: {
    color: theme.palette.secondary.main,
    whiteSpace: 'nowrap',
  },
  providerContainer: {
    marginBottom: theme.spacing(0),
  },
}))

const ProviderItem = observer(({ provider }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Grid container>
      <Accordion
        sx={theme => ({
          boxShadow: 'none',
          backgroundColor: 'inherit',
          flex: 1,
        })}
        className={classes.bioAccordion}
        expanded={provider.activeAccordion}
        onChange={(event, expanded) => {
          if (!provider.bio) return
          event.stopPropagation()
          provider.toggleAccordion(expanded)
        }}
      >
        <AccordionSummary>
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            className={classes.providerContainer}
          >
            <Avatar className={classes.avatar} src={provider.photoUrl} />
            <Grid container direction="column">
              <Typography variant="subtitle1" component="p">
                {provider.name}
              </Typography>
              {provider.specialtyList && (
                <Typography variant="caption" component="p">
                  {t(provider.specialtyList)}
                </Typography>
              )}
              {provider.partnerTier ? (
                <PartnerTierLabel partnerTier={provider.partnerTier} />
              ) : null}
            </Grid>
            {provider.bio ? (
              <Typography variant="subtitle2" className={classes.bioButton}>
                {provider.activeAccordion ? t('Hide Bio') : t('View Bio')}
              </Typography>
            ) : null}
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2">{provider.bio}</Typography>
        </AccordionDetails>
      </Accordion>
    </Grid>
  )
})

ProviderItem.displayName = 'ProviderItem'

export default ProviderItem
